module.exports = __webpack_public_path__ + "img/icon-twitter.13c5e35d.svg";